import React from "react";
import { useNavigate } from "react-router-dom";
import { useOrder } from "../context/OrderContext";
import "./CookingBadge.css";

const CookingBadge = () => {
  const { activeOrder, isProcessing, orderHasFailedItem } = useOrder();
  const navigate = useNavigate();

  if (!activeOrder || !isProcessing) {
    return null;
  }

  // Only show when status is cooking or processing (or when item failed)
  if (!["processing", "cooking"].includes(activeOrder.order_status) && !orderHasFailedItem) {
    return null;
  }

  const handleClick = () => {
    navigate(`/order-status/${activeOrder.order_id}`);
  };

  const isFailed = orderHasFailedItem;

  return (
    <div className={`cooking-badge ${isFailed ? "cooking-badge--failed" : ""}`} onClick={handleClick}>
      <div className="cooking-content">
        <div className="cooking-icon-container">
          <span className="cooking-icon">{isFailed ? "⚠️" : "🔥"}</span>
          <div className="cooking-pulse"></div>
        </div>
        <div className="cooking-text-container">
          <span className="cooking-label">{isFailed ? "Order issue - see counter" : "Cooking..."}</span>
          <span className="cooking-order">
            Order #{activeOrder.order_number}
          </span>
        </div>
        <span className="cooking-arrow">→</span>
      </div>
    </div>
  );
};

export default CookingBadge;
